import axios, { AxiosResponse } from 'axios'
import { FetchApiDataOptions } from '../redux/Types/reduxTypes'
import * as Sentry from '@sentry/react'

const callApi = async (options: FetchApiDataOptions): Promise<AxiosResponse> => {
  const { url, token, method, responseType, bodyData } = options

  // Benutzerdefinierter Replacer für JSON.stringify
  const jsonReplacer = (_key: string, value: any) => {
    if (value instanceof Date || typeof value === 'number') {
      return value instanceof Date ? value.toISOString() : value.toString()
    }
    return value
  }

  try {
    let config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }

    let response: AxiosResponse

    if (method === 'GET' || method === 'DELETE') {
      // GET und DELETE Anfragen
      response = await axios({
        method: method,
        responseType: responseType,
        url: url,
        headers: config.headers,
      })
    } else {
      // POST, PUT, und andere Methoden mit Body
      response = await axios({
        method: method,
        responseType: responseType,
        url: url,
        data: JSON.stringify(bodyData, jsonReplacer),
        headers: config.headers,
      })
    }
    return response
  } catch (error) {
    Sentry.captureException(error)
    // Fehlerbehandlung oder Weitergabe des Fehlers
    throw error
  }
}

export default callApi
